import React from 'react';
import './Modal.css';

const Modal = ({ show, onClose, title, children, size }) => {
  if (!show) {
    return null;
  }

  const contentClassName = `modal-content ${size ? `modal-content--${size}` : ''}`;

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className={contentClassName} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h4 className="modal-title">{title}</h4>
          <button onClick={onClose} className="close-button">&times;</button>
        </div>
        <div className="modal-body">{children}</div>
      </div>
    </div>
  );
};
export default Modal;